import React, { useState } from "react";
import OverlayWrapper from "../../Components/OverlayWrapper/OverlayWrapper";
import EnquiryForm from "../../Components/EnquiryForm/EnquiryForm";

const UnMountedComponent = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button variant="contained" onClick={() => setOpen(true)}>
        Open Overlay
      </button>
      <OverlayWrapper open={open} onClose={() => setOpen(false)}>
        <EnquiryForm />
      </OverlayWrapper>
      <EnquiryForm />
    </>
  );
};

export default UnMountedComponent;
